import React from 'react';
import PropTypes from 'prop-types';

import { Container } from './styles';

const Props = {
  children: PropTypes.node.isRequired,
};

export default function PageTitle({ children }) {
  return <Container>{children}</Container>;
}

PageTitle.propTypes = Props;
